<template>
  <section class="hero is-black is-fullheight">

    <!-- Header & Tab controls -->
    <div class="hero-head">
      <div class="container">
        <h1 class="title">
          <strong>Archive</strong>
        </h1>
        <div class="tabs is-toggle is-fullwidth is-small">
          <ul>
            <li v-for="(view, index) in views"
                :class="{ 'is-active': isViewActive(view.value) }"
                :key="`view-${index}`" >
              <a @click="updateSelection(view.value)">
                <span>{{ view.name | capitalize }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Collections View -->
    <div v-if="selectedView === 'collection'" class="hero-body">
      <div class="container">
        <div v-for="(collection, index) in collections" :key="`collection-${index}`">
          <ArchiveCollection
            @open-details="showObjectDetails"
            :collection="collection"
            :objects="objects" >
          </ArchiveCollection>
        </div>
      </div>
    </div>

    <!-- Archive Grid -->
    <div v-else class="hero-body">
      <div class="container">
        <ArchiveGrid
          @open-details="showObjectDetails"
          :objects="objects">
        </ArchiveGrid>
      </div>
    </div>

    <!-- Modal details viewer -->
    <archive-details v-if="currentDetails"
                     :isActive="modalVisible"
                     :details="currentDetails"
                     @close-details="hideObjectDetails" ></archive-details>

  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import ArchiveGrid from '@/components/ArchiveGrid.vue'
import ArchiveCollection from '@/components/ArchiveCollection.vue'
import ArchiveDetails from '@/components/ArchiveDetails.vue'
export default {
  name: 'archive',
  components: { ArchiveCollection, ArchiveGrid, ArchiveDetails },

  computed: {
    ...mapGetters(['chapter'])
  },

  created: function () {
    let archiveData = require(`@/assets/data/${this.chapter.shortname}/archive.yml`)
    this.collections = archiveData.collections
    this.objects = archiveData.objects
  },

  data () {
    return {
      collections: [],
      objects: [],
      currentDetails: null,
      modalVisible: false,
      selectedView: 'collection',
      views: [
        { name: 'Collection View', value: 'collection' },
        { name: 'Grid View', value: 'grid' }
      ]
    }
  },

  methods: {
    filterByType (array) {
      if (this.selection === 'all') {
        return array
      } else {
        return array.filter((item) => {
          return item.type === this.selection
        })
      }
    },

    isViewActive (view) {
      return view === this.selectedView
    },

    showObjectDetails (object) {
      this.currentDetails = object
      this.modalVisible = true
    },

    hideObjectDetails () {
      this.modalVisible = false
    },

    updateSelection (view) {
      this.selectedView = view
    }
  },

  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
}
</script>
<style scoped>
.title { padding-top: 1em; }

.hero.is-fullheight {
  min-height: calc(100vh - 3.25rem);
}

.hero.is-halfheight .hero-body,
.hero.is-fullheight .hero-body {
  align-items: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/components/Archive.vue?7d22b55c